import type { ChurnDimension, ChurnWarningV2TemplateArgs } from '../../../server/dto/insight-dto.ts';

export const churnV2TooltipDimensions: ChurnDimension[] = [
    'd2_cadence',
    'd3_annual',
    'd4_seasonal',
    'd5_revenue',
    'd6_momentum',
];

export function hasChurnV2Tooltip(dim: ChurnDimension): boolean {
    return churnV2TooltipDimensions.includes(dim);
}

function convertToMonths(days: number): number {
    return Math.ceil(days / 30);
}

export function churnV2TooltipLength(dim: ChurnDimension, args: ChurnWarningV2TemplateArgs): number {
    switch (dim) {
        case 'd2_cadence':
            return convertToMonths(args.d2_period_length ?? 30);
        case 'd4_seasonal':
            return args.d4_period_length ?? 3;
        case 'd6_momentum':
            return 6;
        default:
            return 12; // d3_annual, d5_revenue
    }
}

/**
 * The single dimension a churn v2 card describes: the one the EUR figure was computed over.
 *
 * Prefers `revenue_impact_dimension`, and only when it has tooltip copy. Falls back to the scoring
 * ranking for batches that predate it, skipping dimensions with no period of their own.
 */
export function churnV2CardDimension(args: ChurnWarningV2TemplateArgs): ChurnDimension {
    return (
        [
            args.revenue_impact_dimension,
            args.top_dimension_1,
            args.top_dimension_2,
            args.top_dimension_3,
        ].find((dim): dim is ChurnDimension => !!dim && hasChurnV2Tooltip(dim)) ?? args.top_dimension_1
    );
}
